import { useTranslation } from "react-i18next"
import { Typography } from "@material-ui/core"
import EmptyPage from "../common/EmptyPage"
import { ReactComponent as EmptyMonitor } from "../images/empty-monitor.svg"

const MonitorEmpty = () => {
    const { t } = useTranslation()

    return (
        <EmptyPage>
            <EmptyMonitor />
            <div>
                <Typography className="text-center mb-4">{t(`You have no submission to review`)}</Typography>
            </div>
        </EmptyPage>
    )
}

export default MonitorEmpty
